import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TOUR_STEPS } from "@/lib/tourSteps";
import { TourOverlay } from "@/components/TourOverlay";

const STORAGE_KEY = "inviktus_tour";
const TourContext = createContext(null);

const readStored = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
};

export function TourProvider({ children }) {
  const [tour, setTour] = useState(readStored);
  const { pathname } = useLocation();

  useEffect(() => {
    if (tour) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tour));
    else sessionStorage.removeItem(STORAGE_KEY);
  }, [tour]);

  const start = useCallback((cfg) => setTour({ ...cfg, step: 0, auto: false }), []);
  const toggleAuto = useCallback(() => setTour((t) => t && { ...t, auto: !t.auto }), []);
  const stop = useCallback(() => setTour(null), []);
  const go = useCallback(
    (delta) =>
      setTour((t) => {
        if (!t) return t;
        const step = t.step + delta;
        if (step >= TOUR_STEPS.length) return t.auto ? { ...t, step: 0 } : null;
        return { ...t, step: Math.max(0, step) };
      }),
    []
  );

  return (
    <TourContext.Provider value={{ tour, start, stop, toggleAuto, next: () => go(1), prev: () => go(-1) }}>
      {children}
      {tour && !pathname.startsWith("/demo/") && <TourOverlay />}
    </TourContext.Provider>
  );
}

export const useTour = () => useContext(TourContext);
